import { useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/api';

/**
 * Contatore ticket non letti condiviso (sidebar desktop + drawer mobile).
 * Si aggiorna: al mount, ogni 60s, al cambio di `refreshKey` (es. route)
 * e sull'evento window 'tickets-updated'.
 */
export function useTicketsUnread(enabled, refreshKey) {
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const res = await api.getTicketsUnread();
      setUnread(res.unread || 0);
    } catch { /* silenzioso */ }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    refresh();
    const interval = setInterval(refresh, 60000);
    const onUpdate = () => refresh();
    window.addEventListener('tickets-updated', onUpdate);
    return () => { clearInterval(interval); window.removeEventListener('tickets-updated', onUpdate); };
  }, [enabled, refresh, refreshKey]);

  return unread;
}
